import { getImage } from "../../../services/image-utils";

type HandMessageProps = {
  children: string | React.ReactNode | React.ReactNode[];
  color: string;
  extended?: boolean;
};

export const CBHandMessage = ({
  color,
  children,
  extended,
}: HandMessageProps) => {
  let logo;
  let bgClass = `flex mx-auto relative rounded-full px-6 py-2 ${extended ? "max-w-[400px]" : "max-w-[350px]"}  h-20 items-center `;

  if (color === "gray") {
    logo = getImage("/assets/hand-gray.png");
    bgClass += "bg-slate-100";
  } else {
    logo = getImage("/assets/hand-orange.png");
    bgClass += "bg-orange-100";
  }

  return (
    <div className={bgClass}>
      <img
        src={logo}
        className="max-h-16 mr-3.5 ml-3.5 absolute inset-x-0 bottom-0"
      />
      <p className="ml-12 my-2" style={{ fontSize: "14px" }}>
        {children}
      </p>
    </div>
  );
};
